import { SKU_MOVEMENT_MESSAGES, SkuMovementMessages } from "./sku-movement.messages";
import { SKU_REQUEST_MESSAGES, SkuRequestMessages } from "./sku-requet.messages";
import { SKU_TABLE_MESSAGES, SkuTableMessages } from "./sku-table.messages.";
import { ACTION_BUTTON_MESSAGES, ActionButtonMessages } from "../action-buttons.messages";
import { POPOVER_MESSAGES, PopoverMessages } from "../popover.messages";
import { KIT_TABLE_MESSAGES, KitTableMessages } from "../products/kit-table.messages";

export type SkuFormMessages = ActionButtonMessages &
  SkuRequestMessages &
  SkuTableMessages &
  PopoverMessages &
  KitTableMessages &
  SkuMovementMessages & {
    // Group Titles
    informationGroupTitle: string;
    pricingGroupTitle: string;
    variationTitle: string;
    skuInformationTitle: string;
    storageTitle: string;
    pricingTitle: string;

    // Label messages
    titleLabel: string;
    codeLabel: string;
    eanLabel: string;
    videoUrlLabel: string;
    stockLabel: string;
    reservedStockLabel: string;
    statusLabel: string;
    kitLabel: string;
    activeLabel: string;
    inactiveLabel: string;

    mainPriceLabel: string;
    promotionalPriceLabel: string;
    promotionStartLabel: string;
    promotionEndLabel: string;

    variationLabel: string;
    variationValueLabel: string;
    weightLabel: string;
    heightLabel: string;
    widthLabel: string;
    depthLabel: string;
    dimensionLabel: string;
    leadTimeLabel: string;
    stockHistoryLabel: string;
    variationImageLabel: string;
    variationImageHelp: string;
    variationImageDefaultOption: string;
    productHasLimitedImages: string;

    // Options
    noVariationOption: string;

    // Error messages
    errorRequiredTitle: string;
    errorRequiredCode: string;
    errorRequiredPrice: string;
    errorRequiredPromotionDate: string;
    errorRequiredPromotionalPrice: string;
    errorRequiredPromotionDates: string;
    errorRequiredVariationValue: string;
    errorRequiredMainPrice: string;
    errorRequiredVariationCode: string;
    errorStartPromoPriceMustBeBeforeEndPromoPrice: string;
    errorEndPromoPriceMustBeAfterStartPromoPrice: string;
    errorMainPriceGreaterThanZero: string;
    errorRequiredPromotionStartDate: string;
    errorRequiredPromotionEndDate: string;
    errorPromoPriceWithInvalidDates: string;
    errorPromoPriceGreaterThanZero: string;
    errorAllVariationsMustHaveAValue: string;
    errorProductMustHaveTitle: string;
    errorWeightPrecision: string;
    errorHeightInteger: string;
    errorWidthInteger: string;
    errorDepthInteger: string;
    errorLeadTimeInteger: string;
    noSkusAdded: string;
    //Button
    insertNewSkuButton: string;
  };

export const SKU_FORM_MESSAGES: SkuFormMessages = {
  // Group Titles
  informationGroupTitle: "Informações",
  pricingGroupTitle: "Preços",
  variationTitle: "Variações",
  skuInformationTitle: "Informações do SKU",
  storageTitle: "Armazenamento",
  pricingTitle: "Precificação",

  // Labels messages
  titleLabel: "Nome do produto",
  codeLabel: "Código (SKU)",
  eanLabel: "GTIN/EAN",
  videoUrlLabel: "URL do vídeo",
  stockLabel: "Estoque",
  reservedStockLabel: "Quantidade Reservada",
  statusLabel: "Ativo/Inativo",
  kitLabel: "KIT",
  activeLabel: "Ativo",
  inactiveLabel: "Inativo",

  mainPriceLabel: "Preço venda",
  promotionalPriceLabel: "Preço promocional",
  promotionStartLabel: "Início da promoção",
  promotionEndLabel: "Fim da promoção",

  variationLabel: "Variação",
  variationValueLabel: "Valor da Variação",
  weightLabel: "Peso Bruto(Kg)",
  heightLabel: "Altura(cm)",
  widthLabel: "Largura(cm)",
  depthLabel: "Profundidade(cm)",
  dimensionLabel: "Dimensão (cm³)",
  leadTimeLabel: "Prazo de preparação e manuseio (dias)",
  stockHistoryLabel: "Histórico de Movimentação de Estoque",
  variationImageLabel: "Imagem da Variação (opcional)",
  variationImageHelp:
    "Se não selecionado, a imagem do SKU será a imagem padrão do produto.",
  variationImageDefaultOption: "Usar imagem padrão do produto",
  productHasLimitedImages: "Produto possui {count} imagem(ns). O SKU usará a imagem padrão do produto.",

  // Options
  noVariationOption: "Nenhuma variação",

  // Error messages
  errorRequiredTitle: "O titulo é obrigatório!",
  errorRequiredCode: "O código é obrigatório!",
  errorRequiredPrice: "O preço é obrigatório!",
  errorRequiredPromotionDate: "A data de início da promoção é obrigatória!",
  errorRequiredPromotionalPrice: "O preço promocional é obrigatório!",
  errorRequiredVariationValue: "O valor da variação é obrigatório!",
  errorRequiredMainPrice: "O preço principal é obrigatório!",
  errorRequiredVariationCode: "O código de variação é obrigatório!",
  errorStartPromoPriceMustBeBeforeEndPromoPrice:
    "A data de início da promoção deve ser anterior à data de término da promoção!",
  errorEndPromoPriceMustBeAfterStartPromoPrice:
    "A data de término da promoção deve ser posterior à data de início da promoção!",
  errorMainPriceGreaterThanZero: "O preço principal deve ser maior que zero!",
  errorRequiredPromotionStartDate:
    "A data de início da promoção é obrigatória quando o preço promocional é informado.",
  errorRequiredPromotionEndDate:
    "A data de término da promoção é obrigatória quando o preço promocional é informado.",
  errorRequiredPromotionDates:
    "As datas de início e fim da promoção são obrigatórias quando um preço promocional é definido.",
  errorPromoPriceWithInvalidDates:
    "As datas de promoção são inválidas para o preço promocional informado.",

  errorPromoPriceGreaterThanZero:
    "O preço promocional deve ser maior que zero quando as datas de promoção estão definidas.",

  errorAllVariationsMustHaveAValue: "Todas as variações devem ter um valor.",
  errorProductMustHaveTitle: "O produto deve ter um nome antes de adicionar um SKU.",

  errorWeightPrecision: "Peso deve estar no formato 0.000 (três casas decimais).",
  errorHeightInteger: "Altura deve ser um número inteiro.",
  errorWidthInteger: "Largura deve ser um número inteiro.",
  errorDepthInteger: "Profundidade deve ser um número inteiro.",
  errorLeadTimeInteger: "Prazo de preparação e manuseio deve ser um número inteiro.",

  // New message for empty table
  noSkusAdded: "Nenhuma SKU foi adicionada a este produto",

  //Button
  insertNewSkuButton: "Novo Sku",

  ...KIT_TABLE_MESSAGES,
  ...POPOVER_MESSAGES,
  ...SKU_TABLE_MESSAGES,
  ...ACTION_BUTTON_MESSAGES,
  ...SKU_REQUEST_MESSAGES,
  ...SKU_MOVEMENT_MESSAGES,
};
